import { NavLink } from "react-router-dom";
import { Box, Tooltip } from "@mui/material";
import { ProgressBar } from "@components";
import { WORKSPACES_PATH } from "pages/router";
import type { IProject } from "features/projects/types";
import type { IWorkspaceId } from "features/workspaces/types";
import {
  projectStyle,
  projectBarStyle,
  projectBarNameStyle,
  projectBarProgressStyle,
  projectBarCountStyle,
} from "./styles";

export const Project = ({ project, workspaceId }: { project: IProject; workspaceId: IWorkspaceId }) => {
  const toProject = `/${WORKSPACES_PATH}/${workspaceId}/${project.id}`;

  return (
    <NavLink to={toProject} className="link--box">
      <Box sx={projectStyle}>
        <Box sx={projectBarStyle}>
          <Box sx={projectBarNameStyle}>{project.name}</Box>
          <Box sx={projectBarProgressStyle}>
            <ProgressBar percentage={project.completenessPercents} />
          </Box>
          <Box sx={projectBarCountStyle}>
            <Tooltip title="Approved / Total phrases">
              <Box component="span">
                {project.approvedPhrasesCount} / {project.phrasesCount}
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </NavLink>
  );
};
